import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { BulkDeleteSignupCommandInput, BulkDeleteSignupCommandOutput } from '@amzn/red-velvet-api';
import { useFeatures, getEnabledFeatures } from '../features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'bulkSignupDelete'];

export function useBulkDeleteSignup(eventId: string) {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<BulkDeleteSignupCommandOutput, Error, BulkDeleteSignupCommandInput>({
    mutationKey: [...MUTATION_PREFIX, eventId],
    mutationFn: (input) => client.bulkDeleteSignup(input),
  });
}
